import React, { FC, useState } from 'react';
import { SearchUniversal } from '@duxton-web/icons';
import { Input } from '@duxton-web/ui';

interface ISearch {
  onSearch: (searchVal: string) => void;
}

const Search: FC<ISearch> = ({ onSearch }) => {
  const [searchVal, updateSearchVal] = useState<string>('');

  return (
    <Input.Search
      className="variables-search"
      placeholder="Search by name and description"
      enterButton={<SearchUniversal twoToneColor={'#FFF'} />}
      size="large"
      onChange={(e) => updateSearchVal(e.target.value)}
      onSearch={() => {
        onSearch(searchVal);
      }}
      style={{
        width: 400,
      }}
    />
  );
};

export default Search;
